import { Box, Stack } from '@mui/material';
import { WsInputNumber, HourglassIcon } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const NoticePeriod = ({ name, title, showAccordionIcon }: WsFilterProps) => (
  <WsAccordion
    title={title ?? 'Notice Period'}
    {...(showAccordionIcon && { startIcon: <HourglassIcon /> })}
  >
    <Box>
      <Stack direction="row" spacing={2} p={2}>
        <WsInputNumber
          name={`${name}.min`}
          label={title ? 'from' : 'Min Days'}
          defaultValue={null}
        />
        <WsInputNumber name={`${name}.max`} label={title ? 'to' : 'Max Days'} defaultValue={null} />
      </Stack>
    </Box>
  </WsAccordion>
);

export default NoticePeriod;
